<template>
  <div class="ac5">
    <!-- 标题 -->
    <div class="ac5-title">
      <h2>热门话题</h2>
    </div>

    <!-- 循环项 -->
    <div
      class="ac5-item"
      v-for="(item, index) in data"
      :key="index"
      @click="gopay()"
    >
      <!-- 左侧图片 -->
      <div class="item-img">
        <img :src="item.img" alt="" />
      </div>
      <!-- 右侧标题 -->
      <div class="item-title">
        <p>{{ item.title }}</p>
        <!-- <span><i class="iconfont icon-time"></i> {{ item.time }}</span> -->
      </div>
    </div>
      <modal
      title="请微信扫码支付"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img
          style="display: flex; justify-content: center; margin: 0 auto"
          src="/imgs/pay2.png"
        />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac5",
   components: {
    Modal,
  },
  data() {
    return {
      data: [],
       showModal: false,
    };
  },
  mounted() {
    this.init();
   
  },
  methods: {
    init() {
      this.axios.get("/mock/ac1.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.data = data.splice(6, 10);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("资讯收费2元，请扫码购买~");
       this.showModal = true;
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac5 {
  width: 100%;
  // 标题
  .ac5-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;
    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        color: $colorZ;
      }
    }
  }

  //  循环项
  .ac5-item {
    width: 100%;
    height: 130px;
    // background-color: pink;
    background: #eee;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin: 10px auto;
    // 左侧图片
    .item-img {
      width: 130px;
      height: 130px;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    // 右侧标题
    .item-title {
      font-size: 14px;
      font-weight: bold;
      color: #555;
      cursor: pointer;
      p {
        margin: 20px 0;
        transition: all 0.3s;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: $colorZ;
        }
      }
      span {
        i {
          font-size: 14px;
          margin-right: 5px;
        }
        font-size: 14px;
        color: 888;
      }
    }
  }
}
</style>